// extracted by mini-css-extract-plugin
export default {"Container":"AddBook_Container__gGwa5","Created":"AddBook_Created__gdyTn"};